import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSave, faPen } from "@fortawesome/free-solid-svg-icons";
import { toast } from "react-toastify";
import api from "../api/api";

const EditAdditionalInfo = ({ item, type = "deliveries", onSave, canEdit }) => {
  const [additionalInfo, setAdditionalInfo] = useState(
    item.additional_info || ""
  );
  // const [isSubmitting, setIsSubmitting] = useState(false);
  const [isEditing, setIsEditing] = useState(false);

  const handleSave = async () => {
    // setIsSubmitting(true);
    try {
     await api.put(`/${type}/${item.id}`, {
        additional_info: additionalInfo,
        editAdditionInfo: true,
      });
      toast.success("Additional information updated successfully.");
      onSave(true); // Callback with updated data
      setIsEditing(false); // Exit edit mode
    } catch (error) {
      toast.error("Failed to update additional information.");
    } finally {
      // setIsSubmitting(false);
    }
  };

  const toggleEditMode = () => {
    if (canEdit()) {
      if (isEditing) {
        // Save changes if currently in edit mode
        handleSave();
      } else {
        // Enable edit mode
        setIsEditing(true);
      }
    }
  };

  return (
    <div className="space-y-4 mt-6">
      <div className="flex items-center justify-between">
        <h3 className="text-lg font-semibold text-gray-700 flex items-center">
          Additional Information
          {canEdit() && (
            <button
              onClick={toggleEditMode}
              className="ml-2 text-blue-500 hover:text-blue-600 focus:outline-none"
            >
              <FontAwesomeIcon icon={isEditing ? faSave : faPen} />
            </button>
          )}
        </h3>
      </div>

      {/* Textarea for Additional Info */}
      <textarea
        value={additionalInfo}
        onChange={(e) => setAdditionalInfo(e.target.value)}
        disabled={!isEditing}
        className={`w-full h-32 px-3 py-2 border rounded-md focus:outline-none ${
          isEditing
            ? "focus:border-purple-500"
            : "bg-gray-100 cursor-not-allowed"
        }`}
        placeholder="Enter any additional information here..."
      />
    </div>
  );
};

export default EditAdditionalInfo;
